import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import  {VouchersComponent} from "./VouchersComponent";


const UserCard = ({ user }) => {
  const [userVouchers, setUserVouchers] = useState([]);
  const [unUsedVouchers, setUnUsedVouchers] = useState({});
   const getUserVouchers = async() => {
     try{
       const userVouchers = await axios.get('/getloggedinusersvouchers');
       const vouchers = userVouchers.data.usersVouchers;
        const unUsedVoucher = vouchers.find( (voucher) => voucher.is_used === false );
        setUnUsedVouchers(unUsedVoucher);
        setUserVouchers(vouchers);
     }catch(e){
       console.log(e);
     }
   }
   
   const handleReedemVoucher = async(e) => {
     const id = unUsedVouchers.id;
     const config = {
       headers: {
         "Content-Type": "application/json",
        },
      };
      const body = {
        "voucher_id":id
      }
      const redeemVoucher = await axios.post('/redeemvoucher', body, {config});
      
      return redeemVoucher
    }
    useEffect(() => {
      getUserVouchers();
    }, []);
  return (
    <Fragment>
        <div className="container">
      <div className="user-card d-flex flex-column justify-content-center align-items-center">
        <div className="dashboard-card mt-5 remove-margin-mobile">
          <h1>Welcome {user.username.toUpperCase()}</h1>
        </div>
        {unUsedVouchers ?
          (<div className="dashboard-card d-flex flex-column justify-content-center align-items-center mt-3 p-lg-5">
            <h1>Redeem Voucher</h1>
              <small style={{padding:"15px"}}>Amount: {unUsedVouchers.value}</small>
              <small style={{padding:"8px"}}>Network: {unUsedVouchers.network}</small>
              <small style={{padding:"15px"}}>Code: {unUsedVouchers.token}</small>
            <i style={{fontSize: '50px'}} className="fa fa-credit-card"></i>
            <button className="btn btn-success mt-5" onClick={handleReedemVoucher}>Redeem</button>
          </div>)
          :
          (  <div className="user-card d-flex flex-column justify-content-center align-items-center">
            <div className="dashboard-card mt-5 remove-margin-mobile">
              <h1>You currently have no vouchers to reedem</h1>
            </div>
              </div>
            )}

      </div>

        <VouchersComponent vouchers={userVouchers} title="Your Vouchers"/>
      </div>



    </Fragment>
  );
};

export default UserCard;
